import { Component } from 'react';

interface SaleTimelineEntry {
    year: string;
    price: string;
}

interface SaleTimelineProps {
    valuation: any;
}

class SaleTimeline extends Component<SaleTimelineProps> {
    formatCompactPrice(value: number): string {
        if (value >= 1000000) return `€${(value / 1000000).toFixed(1)}M`;
        if (value >= 1000) return `€${Math.round(value / 1000)}K`;
        return `€${Math.round(value)}`;
    }

    getEntries(): SaleTimelineEntry[] {
        const salesHistory = this.props.valuation?.["sh"];
        if (!salesHistory || typeof salesHistory !== "object") return [];
        return Object.keys(salesHistory)
            .sort()
            .filter(dateKey => salesHistory[dateKey]?.p?.v)
            .map(dateKey => {
                const sale = salesHistory[dateKey];
                const dateStr = sale?.d || dateKey;
                const year = dateStr.length >= 4 ? dateStr.substring(0, 4) : dateStr;
                return { year, price: this.formatCompactPrice(sale.p.v) };
            });
    }

    render() {
        const entries = this.getEntries();
        if (entries.length === 0) return null;

        return (
            <div className="sale-timeline">
                <div className="sale-timeline-title sale-timeline-pre-align">Historical Sales </div>
                <span className="sale-timeline-dot sale-timeline-dot-cap sale-timeline-pre-align" />
                <span className="sale-timeline-dot sale-timeline-dot-cap sale-timeline-pre-align" />
                <div className="sale-timeline-track">
                    <div className="sale-timeline-entry sale-timeline-cap">
                        <span className="sale-timeline-dot sale-timeline-dot-cap" />
                    </div>
                    {entries.map((entry, i) => (
                        <div key={i} className="sale-timeline-entry">
                            <span className="sale-timeline-price">{entry.price}</span>
                            <span className="sale-timeline-dot" />
                            <span className="sale-timeline-year">{entry.year}</span>
                        </div>
                    ))}
                    <div className="sale-timeline-entry sale-timeline-cap">
                        <span className="sale-timeline-dot sale-timeline-dot-cap" />
                    </div>
                </div>
            </div>
        );
    }
}

export default SaleTimeline;
